import React from 'react';
import { useTranslation } from 'react-i18next';

import Table from '../../../components/common/table/table';
import Title from '../../../components/common/title';
import SystemConfiguration from '../../../interfaces/systemConfiguration';
import { INTERNAL_SYSTEM_PROPERTIES_EDIT } from '../../../router/routes';
import { useService } from '../../../services/services';
import css from './index.module.css';

export default function SystemConfigurations() {
  const { t } = useTranslation();
  const { systemPropertyService } = useService();

  return (
    <div className={css['index']}>
      <Title title={t('System configurations')} />
      <div className={css['body']}>
        <Table<SystemConfiguration>
          request={(page, sort, desc) =>
            systemPropertyService.index(page, sort, desc)
          }
          keyAccessor="id"
          columns={[
            { accessor: 'name', header: t('name'), sortable: true },
            {
              accessor: 'description',
              header: t('description'),
              sortable: true,
            },
            { accessor: 'value', header: t('value'), sortable: true },
          ]}
          viewRoute={INTERNAL_SYSTEM_PROPERTIES_EDIT}
          viewRecordAbility={{ title: 'Manage system configurations' }}
        />
      </div>
    </div>
  );
}
